module.exports = require("core-js/library/fn/symbol/to-primitive");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/symbol/to-primitive.js
// module id = 638
// module chunks = 0